export enum CONTRACT_EXPIRE_STATUS {
    normal = 0,
    willExpire = 1,
    hadExpire = 2,
}

// 服务商账号信息
export interface IAccountRes {
    account: string;
    address: string;
    contractExpireStatus: CONTRACT_EXPIRE_STATUS;
    logoUrl: string;
    msgSwitch: number;
    phone: string | null;
    renewalDeadline: number | null;
    serviceProviderName: string;
}

export enum PROTOCOL_STATUS {
    /** 不同意 */
    unAgree = 0,
    /** 同意过 */
    agree = 1,
}

export interface IProtocolStatusRes {
    isAgree: PROTOCOL_STATUS;
}

export interface IProviderReq {
    providerId: number;
}

export interface ISystemConfigRes {
    couponMenuConfig: number;
}

export interface IDynamicMenuRes {
    icon: string;
    id: number;
    name: string;
    url: string;
    menuCode: string;
}
// 服务商公告消息
export interface IAnnouncement {
    title: string;
    id: number;
}
